<template>
    <section>
        <div class="progress">
            <div
                class="progress-bar"
                :style="{ width: progressPercentage }"
                role="progressbar"
                aria-valuenow="0"
                aria-valuemin="0"
                aria-valuemax="100"
            ></div>
        </div>
    </section>
</template>

<script>
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import round from 'lodash/round'

export default {
    data() {
        return {
            value: null,
        }
    },
    setup() {
        const store = useStore()
        const route = useRoute()

        return {
            store,
            route
        }
    },
    computed: {
        progressPercentage() {
            const currentStepIndex = this.store.getters.stepViaRouteName(this.route.name)?.index ?? this.store.getters.getCompletedStepsCurrentPath

            return Math.min(100, round((currentStepIndex / this.store.getters.getTotalStepsCurrentPath) * 100, 0)) + '%'
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/mixins/rem';

.progress {
    height: 4px;
    border-radius: 10px;

    .progress-bar {
        background: var(--wizard-progress-bar-color);
    }
}
</style>
